import { initLogging } from "@expert/logging";
import { getFullStoryUrlSync } from "@expert/monitoring";

import { env } from "@/config";

initLogging({
    appName: env.appName,
    commitHash: env.commitHash,
    logLevel: env.logLevel,
    channel: env.channel,
    isConsoleLogEnabled: !env.disableConsoleLogs,
    mixin: () => ({ fullStoryUrl: getFullStoryUrlSync() ?? "not defined" }),
});
